import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useState, type ReactElement, type SubmitEvent } from 'react';

import { TermsConsent } from './TermsConsent';

export type TermsConsentFormProps = {
    submitLabel: string;
    isPending: boolean;
    errorMessage?: string;
    onSubmit: () => void;
};

export function TermsConsentForm({
    submitLabel,
    isPending,
    errorMessage,
    onSubmit,
}: TermsConsentFormProps): ReactElement {
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const handleSubmit = (event: SubmitEvent<HTMLFormElement>): void => {
        event.preventDefault();
        if (!agreedToTerms || isPending) {
            return;
        }
        onSubmit();
    };

    return (
        <Stack component="form" spacing={2} noValidate onSubmit={handleSubmit}>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
            <TermsConsent checked={agreedToTerms} onChange={setAgreedToTerms} />
            <Button type="submit" variant="contained" fullWidth disabled={!agreedToTerms || isPending}>
                {submitLabel}
            </Button>
        </Stack>
    );
}
